import { FC } from "react";
import { IonFab } from '@ionic/react';
import { AllieFabProps } from "./Fab.types";

export const AllieFab: FC<AllieFabProps> = (props) => <IonFab {...props} />;
